import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { ListBranchModel } from './types-store';
import { UserMembersActionWire, ListBranchWire } from './types';

export const api = {

  loadListBranch: async (
    model: ListBranchModel,
    startIndex: number,
    maxResults: number
  ): Promise<ListBranchWire> => {

    const response = await new RemoteAdminData(endpoints.userMemberSearch)
      .resource<Response>()
      .filter({
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults }),
        includeDisabled: !model?.hideDisabledUsers
      })
      .create({
        ...(!model.showAll && {
          subscriberGroup: {
            id: model.subscriberGroup,
            negated: model.negated
          }
        }),
        ...(!!model?.name && { name: model?.name }),
        ...(!!model?.email?.specifiedText
          ? { email: { emailAddress: model?.email?.specifiedText } }
          : { email: model?.email })
      });

    const json = await response.json();

    return json.data;
  },

  saveChanges: (actions: UserMembersActionWire[], endpoint: string) => {
    return new RemoteAdminData(endpoint)
      .resource<void>()
      .update({ actions });
  }
};
